import LandingNew from "./LandingNew";
export default LandingNew;
